import {
    selectDoc, toggleClass,
    toggleClassAll, selectAll,
    isVisible, hasClass, styles,
    event, selectArr, removeClass, addClass
} from "../utils/utils";

import {initSlider} from "../helpers/service.slider";

const props = {
    main: selectDoc('#MainContent'),
    iframe: selectDoc('#refcandy-candyjar')
}

const initializer = () => {
    props.iframe.onload = function () {
        props.main.style.minHeight = `100vh`;
        props.main.style.height = `${props.iframe.height}`;
        props.iframe.setAttribute('scrolling', 'yes')
    }
}

export const Referrals = {
    init: () => initializer()
}
